import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFirestoreCollection, DocumentChangeAction, AngularFirestoreCollectionGroup, AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-pagos',
  templateUrl: './pagos.component.html',
  styleUrls: ['./pagos.component.scss']
})
export class PagosComponent implements OnInit {

  private pagosCol: AngularFirestoreCollectionGroup<any>;
  public  pagos:    Observable<DocumentChangeAction<any>[]>;
  
  private puntosVentaCol: AngularFirestoreCollection<any>;
  private puntosVenta:    Observable<any[]>;
  public  puntosVentaMap: Map<String,any> = new Map<String,any>();
  
  private vendedoresCol: AngularFirestoreCollection<any>;
  private vendedores:    Observable<any[]>;
  public  vendedoresMap: Map<String,any> = new Map<String,any>();

  private usuariosCol: AngularFirestoreCollection<any>;
  private usuarios:    Observable<any[]>;
  public  usuariosMap: Map<String,any> = new Map<String,any>();  

  public  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatDatepicker, {static: false}) fechaDesdePicker: MatDatepicker<Date>;

  @ViewChild(MatDatepicker, {static: false}) fechaHastaPicker: MatDatepicker<Date>;

  public fechaDesde:Date = null;

  public fechaHasta:Date = null;  


  constructor(
    private afFirestore: AngularFirestore, 
    private snackBar: MatSnackBar,
  ) { 
    this.setFechaDesde( new Date() );
    this.setFechaHasta( new Date() );    
  }

  public displayedColumns = [
    "idpos", "punto", "ruta", "circuito", //del punto de venta    
    "count", 
    "fechaCreacion", "nombreReporta",  //del que reporta
    "fechaConfirmacion", "confirmaNombre",  //del que confirma
    "observaciones",  
    "options"//¿Aprobar? // ¿Eliminar?   
  ];

  ngOnInit() {
    console.log("Query since: "+this.fechaDesde+" to "+this.fechaHasta);
    this.pagosCol = this.afFirestore.collectionGroup<any>(
      "totalPagos", 
      ref => ref.where("fechaCreacion", ">=", this.fechaDesde).where("fechaCreacion", "<", this.fechaHasta) 
    );
    this.pagos    = this.pagosCol.snapshotChanges(); 
    this.pagos.subscribe(
      data => {        
        this.dataSource = new MatTableDataSource<any>(
          data.map(
            (pago)=>{
              return {
                "uid":pago.payload.doc.id,
                "idpos": pago.payload.doc.ref.parent.parent.id,
                ...pago.payload.doc.data(),
              };            
            }
          )
        );        
        this.dataSource.sort      = this.sort;
        this.dataSource.filter    = this.filter; 
      }
    );
    //
    this.puntosVentaCol = this.afFirestore.collection<any>("punto-venta");
    this.puntosVenta    = this.puntosVentaCol.valueChanges();    
    this.puntosVenta.subscribe(
      (lastPuntoVenta)=>{        
        lastPuntoVenta.forEach(
          (puntoVenta)=>{            
            this.puntosVentaMap.set(puntoVenta.idpos, puntoVenta);
          }
        );
      }
    );
    
    this.vendedoresCol = this.afFirestore.collection<any>("vendedor");
    this.vendedores    = this.vendedoresCol.valueChanges();    
    this.vendedores.subscribe(
      (lastVendedores)=>{
        lastVendedores.forEach(
          (vendedor)=>{
            this.vendedoresMap.set(vendedor.id, vendedor);
            this.vendedoresMap.set("+57"+vendedor.celular, vendedor);            
          }
        );
      }
    );

    this.usuariosCol = this.afFirestore.collection<any>("usuario");
    this.usuarios    = this.usuariosCol.valueChanges();    
    this.usuarios.subscribe(
      (lastUsuarios)=>{        
        lastUsuarios.forEach(
          (usuario)=>{     
            this.usuariosMap.set(usuario.uid, usuario);
          }
        );
      }
    );
    
  }

  trackByUid(index, item) {
    return item.uid;
  }

  public setFechaDesde(fechaDesde){        
    this.fechaDesde = fechaDesde;
    this.fechaDesde.setHours(0);
    this.fechaDesde.setMinutes(0);
    this.fechaDesde.setSeconds(0);
    this.fechaDesde.setMilliseconds(0);
  }

  public setFechaHasta(fechaHasta){
    this.fechaHasta = fechaHasta;
    this.fechaHasta.setHours(23);
    this.fechaHasta.setMinutes(59);
    this.fechaHasta.setSeconds(59);
    this.fechaHasta.setMilliseconds(999);
  }

  filter: string = "";
  @ViewChild(MatSort, {static: true}) sort: MatSort;  

  key:string = null;

  applyFilter() {  
    const newKey = ""+this.fechaDesde+"-"+this.fechaHasta;
    if( newKey !== this.key ){
      this.key = newKey;
      console.log("Filter since: "+this.fechaDesde+" to "+this.fechaHasta);
      this.pagosCol = this.afFirestore.collectionGroup<any>(
        "totalPagos", 
        ref => ref.where("fechaCreacion", ">=", this.fechaDesde).where("fechaCreacion", "<=", this.fechaHasta) 
      );
      this.pagos    = this.pagosCol.snapshotChanges(); 
      this.pagos.subscribe(
        data => {          
          this.dataSource = new MatTableDataSource<any>(
            data.map(
              (pago)=>{
                return {
                  "uid":pago.payload.doc.id,
                  "idpos": pago.payload.doc.ref.parent.parent.id,
                  ...pago.payload.doc.data(),
                };            
              }
            )
          );        
          this.dataSource.sort      = this.sort;
          this.dataSource.filter    = this.filter.trim().toLowerCase(); 
          console.log("filter by: "+this.dataSource.filter);
        }
      );
    }    
    else{      
      this.dataSource.filter = this.filter.trim().toLowerCase();
      console.log("filter by: "+this.dataSource.filter);
    }    
  }  

  getNombreReporta(pago){
    if(pago.nombreReporta){
      return pago.nombreReporta; 
    }
    else{
      let vendedor = this.vendedoresMap.get( pago.reporta );
      if( vendedor ){
        return vendedor.nombre;
      }
      else{
        const usuario = this.usuariosMap.get( pago.reporta );
        if( usuario ){
          console.log("phoneNumber :: "+usuario.phoneNumber.substring(3) );
          vendedor = this.vendedoresMap.get( usuario.phoneNumber );
          this.vendedoresMap.set(pago.reporta, vendedor);
          return vendedor.nombre;
        }        
      }      
      return pago.reporta;
    }    
  }

  showDelete(pago){    
    if(confirm("¿Esta seguro de querer eliminar este pago?")){
      const pvDocRef:DocumentReference = this.afFirestore.collection("punto-venta").doc(pago.idpos).ref;
      const paDocRef:DocumentReference = pvDocRef.collection("totalPagos").doc(pago.uid);      
      this.afFirestore.firestore.runTransaction(
        transaction => 
          transaction.get(pvDocRef).then(
            (pvDoc)=>{              
              transaction.update(pvDocRef,{"totalPagos": (pvDoc.data().totalPagos - pago.count)});
              transaction.delete(paDocRef);
            }
          )
      )
      .then(
        (result)=>{
          this.snackBar.open("Pago eliminado","Entiendo",{duration: 1000});
        }
      )
      .catch(
        (error)=>{
          this.snackBar.open("Error inesperado eliminando el pago","Entiendo",{duration: 2000});
        }
      );
    }
  }
}
